// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  background-color: var(--color-bg-dark);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

/* The candidate list uses most of the width of the 1920px EIZO
   monitors the practice works on, so rows stay on one line. Forms and the
   candidate page keep the narrower, more readable 1200px. */
.container--wide {
  max-width: 1500px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

/* The four-colour plus (components/PlusIcon.js) on "Add New Candidate". */
.plus-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

/* The candidate list's Add New Candidate: the Dashboard button's look (plus icon,
   soft glow) at the normal button size. */
.page-header .btn-add-candidate {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.page-header .btn-add-candidate .plus-icon {
  width: 16px;
  height: 16px;
}

.page-header h1 {
  font-size: 2rem;
  color: var(--color-text-light);
}

/* Buttons — outlined in their colour, filled on hover (the format Part 1's
   "Open interview form" introduced). Each variant only sets two variables:
     --btn-color     the outline, the text, and the fill on hover
     --btn-on-color  the text on that fill (dark on the light colours, where
                     white is unreadable)
   An inline style can set them too — style={{ '--btn-color': 'var(--wylie-blue)' }}
   — which is how a button takes a pane's colour without a class of its own.
   Purple and green are the Part 5 / Part 4 frame colours: the brand purple and
   green are too dark to read as an outline on the dark theme. */
.btn-primary,
.btn-secondary,
.btn-small,
.btn-success,
.btn-danger,
.btn-warning,
.btn-view,
.btn-delete,
.btn-blue,
.btn-pink {
  --btn-color: var(--part5-color);
  --btn-on-color: var(--wylie-white);
  padding: 10px 20px;
  background-color: transparent;
  border: 1px solid var(--btn-color);
  border-radius: 5px;
  color: var(--btn-color);
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s, color 0.3s;
}

.btn-primary:hover:not(:disabled),
.btn-secondary:hover:not(:disabled),
.btn-small:hover:not(:disabled),
.btn-success:hover:not(:disabled),
.btn-danger:hover:not(:disabled),
.btn-warning:hover:not(:disabled),
.btn-view:hover:not(:disabled),
.btn-delete:hover:not(:disabled),
.btn-blue:hover:not(:disabled),
.btn-pink:hover:not(:disabled) {
  background-color: var(--btn-color);
  color: var(--btn-on-color);
}

.btn-small {
  padding: 5px 10px;
  font-size: 12px;
  margin-right: 5px;
}

/* After .btn-small, so "btn-small btn-success" takes the variant's colour. */
.btn-primary,
.btn-view {
  --btn-color: var(--part5-color);
}

.btn-secondary {
  --btn-color: #adb5bd;
  --btn-on-color: #1f1f1f;
}

.btn-success {
  --btn-color: var(--part4-color);
  --btn-on-color: #1f1f1f;
}

.btn-danger,
.btn-delete {
  --btn-color: var(--wylie-coral);
}

.btn-warning {
  --btn-color: var(--wylie-cyan);
  --btn-on-color: var(--wylie-black);
}

.btn-blue {
  --btn-color: var(--wylie-blue);
}

.btn-pink {
  --btn-color: var(--wylie-pink);
}

/* ResendLabel (CandidateDetail.js): a sent button's label swaps to "Send again"
   on hover. Both labels share one grid cell so the button never changes size. */
.resend-label {
  display: inline-grid;
  justify-items: center;
}

.resend-label > span {
  grid-area: 1 / 1;
}

.resend-label-again,
button:hover:not(:disabled) .resend-label-sent {
  visibility: hidden;
}

button:hover:not(:disabled) .resend-label-again {
  visibility: visible;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Tables */
.candidate-table {
  width: 100%;
  background-color: var(--color-bg-card);
  border-collapse: collapse;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  overflow: hidden;
}

.candidate-table thead {
  background-color: var(--color-bg-hover);
}

.candidate-table th,
.candidate-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid var(--color-border);
}

.candidate-table th {
  font-weight: 600;
  color: var(--color-text-light);
}

.candidate-table tr:hover {
  background-color: var(--color-bg-hover);
}

/* Short values that read badly split across lines (names, phones, dates,
   status badges, buttons). Email is left free to wrap if it has to. */
.candidate-table td.nowrap {
  white-space: nowrap;
}

/* Flex lives on a wrapper, not the <td>, so the cell keeps table layout. */
.row-actions {
  display: flex;
  gap: 10px;
}

/* Status badges */
.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
  background-color: var(--wylie-purple);
  color: #b494d1;
  width: fit-content;
  align-self: flex-start;
}

/* New Status - Brand Pink */
.status-new {
  background-color: var(--wylie-pink);
  color: var(--wylie-white);
}

/* Part 1 - Interview (the pane's gold yellow; dark text, white is unreadable on it).
   The pale badges are written .status-badge.status-x so their dark text outranks
   \`.info-item span\` on the candidate page, which otherwise turns it light. */
.status-badge.status-cv_received,
.status-badge.status-background_check,
.status-badge.status-phone_interview_scheduled,
.status-badge.status-phone_interview_completed,
.status-badge.status-in_person_interview_scheduled,
.status-badge.status-in_person_interview_completed,
.status-badge.status-trial_day_scheduled,
.status-badge.status-trial_day_completed {
  background-color: var(--part1-color);
  color: #1f1f1f;
}

/* Rejected - Coral, like the Reject button and the Dashboard's Rejected figure */
.status-badge.status-rejected {
  background-color: var(--wylie-coral);
  color: var(--wylie-white);
}

/* Part 2 - Job Offer (Coral) */
.status-offer_sent,
.status-offer_accepted,
.status-references_requested,
.status-reference_received,
.status-referee_details_received {
  background-color: #f05f57;
  color: var(--wylie-white);
}

/* Part 3 - Documents (Blue) */
.status-documents_email_sent,
.status-all_starter_docs_received {
  background-color: #288bcd;
  color: var(--wylie-white);
}

/* Part 4 - Contract (Green). candidate_signed was missing here and showed in the
   default purple (Pascal, 2026-10-17). */
.status-contract_email_sent,
.status-awaiting_contract_signature,
.status-candidate_signed,
.status-contract_signed {
  background-color: #28a745;
  color: var(--wylie-white);
}

/* Part 5 - Onboarding (Purple) */
.status-onboarding_checklist_complete {
  background-color: #9b4fc4;
  color: var(--wylie-white);
}

/* Part 6 - Induction (Pink) */
.status-awaiting_induction_signatures {
  background-color: #dc2565;
  color: var(--wylie-white);
}

/* Part 6 complete - Brand Nav Purple */
.status-induction_folder_complete {
  background-color: var(--wylie-purple);
  color: var(--wylie-white);
}

/* Final Success State - Brand Green */
.status-recruited {
  background-color: var(--wylie-green);
  color: var(--wylie-white);
  font-weight: 600;
}

/* Archive marker. NOT a status — it sits alongside the status badge, because
   archived is a separate axis (an archived candidate keeps whatever status they
   reached). Styled as a secondary marker so it never competes with the status. */
.status-archived {
  background-color: transparent;
  border: 1px solid var(--color-border);
  color: var(--color-text-muted);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  margin-left: 6px;
}

/* Student/trainee → RVN progression: the linked-record tag beside the position. */
.status-badge.status-progression {
  background-color: transparent;
  border: 1px solid var(--part1-color, #F7D002);
  color: var(--part1-color, #F7D002);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  margin-left: 6px;
}

/* Flag badges for forms and documents */
.flag-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  margin-left: auto;
  white-space: nowrap;
}

.flag-badge.flag-warning {
  background-color: rgba(255, 193, 7, 0.2);
  color: #ffc107;
  border: 1px solid #ffc107;
}

.flag-badge.flag-received {
  background-color: var(--wylie-purple);
  color: #e5e7eb;
  border: none;
}

/* Forms */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: var(--color-text-light);
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  font-size: 14px;
  background-color: var(--color-bg-card);
  color: var(--color-text-light);
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--wylie-purple);
  box-shadow: 0 0 0 0.2rem rgba(80, 7, 120, 0.25);
}

.error-message {
  background-color: rgba(240, 95, 87, 0.2);
  color: var(--wylie-coral);
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
  border: 1px solid var(--wylie-coral);
}

/* ---- Next-step glow -------------------------------------------------------
   One element per open part pulses to show what to do next; CandidateDetail
   works out which from the candidate's data. The colour is the nearest
   --glow-color (each part's frame sets its own); a button outside any frame
   falls back to its own --btn-color, then the brand pink. */
.next-glow {
  --_glow: var(--glow-color, var(--btn-color, var(--wylie-pink, #dc2565)));
  animation: nextGlow 4s ease-in-out infinite;
}
@keyframes nextGlow {
  0%, 100% { box-shadow: 0 0 8px 1px color-mix(in srgb, var(--_glow) 40%, transparent); }
  50%      { box-shadow: 0 0 18px 4px color-mix(in srgb, var(--_glow) 80%, transparent); }
}
/* Text that is being waited on (a send-status line, a header label, a number)
   pulses from its own colour to light grey and back. Only the midpoint is
   written: a keyframe that omits a property takes the element's own value, so
   the start and end are whatever colour the text already has — inline styles
   included, since animations sit above them in the cascade. */
.next-glow-text {
  animation: nextGlowText 4s ease-in-out infinite;
}
@keyframes nextGlowText {
  50% { color: #e2e2e2; }
}
/* A muted status line that glows should pulse from the part's colour, not from
   grey. Its colour is an inline \`var(--color-text-muted)\`, so the variable is
   re-pointed here rather than fighting the inline style with !important (which
   would also block the animation). */
.next-glow-tint {
  --color-text-muted: var(--glow-color, var(--btn-color, var(--wylie-pink, #dc2565)));
}
/* Dashboard: everything there glows at once, so it is kept softer. */
.next-glow-soft { animation-name: nextGlowSoft; }
@keyframes nextGlowSoft {
  0%, 100% { box-shadow: 0 0 5px 0 color-mix(in srgb, var(--_glow) 30%, transparent); }
  50%      { box-shadow: 0 0 12px 2px color-mix(in srgb, var(--_glow) 60%, transparent); }
}
@media (prefers-reduced-motion: reduce) {
  .next-glow, .next-glow-text { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;;4DAE4D;AAC5D;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;0CAC0C;AAC1C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;;;;;;;;gEAQgE;AAChE;;;;;;;;;;EAUE,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,6CAA6C;AAC/C;;AAEA;;;;;;;;;;EAUE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA,6EAA6E;AAC7E;;EAEE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;gFACgF;AAChF;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,sCAAsC;EACtC,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;sEACsE;AACtE;EACE,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;;6EAE6E;AAC7E;;;;;;;;EAQE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,iFAAiF;AACjF;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;;;;;EAKE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;yCACyC;AACzC;;;;EAIE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;iFAEiF;AACjF;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,kFAAkF;AAClF;EACE,6BAA6B;EAC7B,6CAA6C;EAC7C,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,YAAY;AACd;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;;;EAGE,aAAa;EACb,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;;;;4DAI4D;AAC5D;EACE,wEAAwE;EACxE,2CAA2C;AAC7C;AACA;EACE,WAAW,yEAAyE,EAAE;EACtF,WAAW,0EAA0E,EAAE;AACzF;AACA;;;;8DAI8D;AAC9D;EACE,+CAA+C;AACjD;AACA;EACE,MAAM,cAAc,EAAE;AACxB;AACA;;;qCAGqC;AACrC;EACE,mFAAmF;AACrF;AACA,qEAAqE;AACrE,kBAAkB,4BAA4B,EAAE;AAChD;EACE,WAAW,uEAAuE,EAAE;EACpF,WAAW,0EAA0E,EAAE;AACzF;AACA;EACE,8BAA8B,eAAe,EAAE;AACjD","sourcesContent":[".App {\n  min-height: 100vh;\n  background-color: var(--color-bg-dark);\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n/* The candidate list uses most of the width of the 1920px EIZO\n   monitors the practice works on, so rows stay on one line. Forms and the\n   candidate page keep the narrower, more readable 1200px. */\n.container--wide {\n  max-width: 1500px;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n/* The four-colour plus (components/PlusIcon.js) on \"Add New Candidate\". */\n.plus-icon {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n/* The candidate list's Add New Candidate: the Dashboard button's look (plus icon,\n   soft glow) at the normal button size. */\n.page-header .btn-add-candidate {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.page-header .btn-add-candidate .plus-icon {\n  width: 16px;\n  height: 16px;\n}\n\n.page-header h1 {\n  font-size: 2rem;\n  color: var(--color-text-light);\n}\n\n/* Buttons — outlined in their colour, filled on hover (the format Part 1's\n   \"Open interview form\" introduced). Each variant only sets two variables:\n     --btn-color     the outline, the text, and the fill on hover\n     --btn-on-color  the text on that fill (dark on the light colours, where\n                     white is unreadable)\n   An inline style can set them too — style={{ '--btn-color': 'var(--wylie-blue)' }}\n   — which is how a button takes a pane's colour without a class of its own.\n   Purple and green are the Part 5 / Part 4 frame colours: the brand purple and\n   green are too dark to read as an outline on the dark theme. */\n.btn-primary,\n.btn-secondary,\n.btn-small,\n.btn-success,\n.btn-danger,\n.btn-warning,\n.btn-view,\n.btn-delete,\n.btn-blue,\n.btn-pink {\n  --btn-color: var(--part5-color);\n  --btn-on-color: var(--wylie-white);\n  padding: 10px 20px;\n  background-color: transparent;\n  border: 1px solid var(--btn-color);\n  border-radius: 5px;\n  color: var(--btn-color);\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.btn-primary:hover:not(:disabled),\n.btn-secondary:hover:not(:disabled),\n.btn-small:hover:not(:disabled),\n.btn-success:hover:not(:disabled),\n.btn-danger:hover:not(:disabled),\n.btn-warning:hover:not(:disabled),\n.btn-view:hover:not(:disabled),\n.btn-delete:hover:not(:disabled),\n.btn-blue:hover:not(:disabled),\n.btn-pink:hover:not(:disabled) {\n  background-color: var(--btn-color);\n  color: var(--btn-on-color);\n}\n\n.btn-small {\n  padding: 5px 10px;\n  font-size: 12px;\n  margin-right: 5px;\n}\n\n/* After .btn-small, so \"btn-small btn-success\" takes the variant's colour. */\n.btn-primary,\n.btn-view {\n  --btn-color: var(--part5-color);\n}\n\n.btn-secondary {\n  --btn-color: #adb5bd;\n  --btn-on-color: #1f1f1f;\n}\n\n.btn-success {\n  --btn-color: var(--part4-color);\n  --btn-on-color: #1f1f1f;\n}\n\n.btn-danger,\n.btn-delete {\n  --btn-color: var(--wylie-coral);\n}\n\n.btn-warning {\n  --btn-color: var(--wylie-cyan);\n  --btn-on-color: var(--wylie-black);\n}\n\n.btn-blue {\n  --btn-color: var(--wylie-blue);\n}\n\n.btn-pink {\n  --btn-color: var(--wylie-pink);\n}\n\n/* ResendLabel (CandidateDetail.js): a sent button's label swaps to \"Send again\"\n   on hover. Both labels share one grid cell so the button never changes size. */\n.resend-label {\n  display: inline-grid;\n  justify-items: center;\n}\n\n.resend-label > span {\n  grid-area: 1 / 1;\n}\n\n.resend-label-again,\nbutton:hover:not(:disabled) .resend-label-sent {\n  visibility: hidden;\n}\n\nbutton:hover:not(:disabled) .resend-label-again {\n  visibility: visible;\n}\n\nbutton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Tables */\n.candidate-table {\n  width: 100%;\n  background-color: var(--color-bg-card);\n  border-collapse: collapse;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.candidate-table thead {\n  background-color: var(--color-bg-hover);\n}\n\n.candidate-table th,\n.candidate-table td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.candidate-table th {\n  font-weight: 600;\n  color: var(--color-text-light);\n}\n\n.candidate-table tr:hover {\n  background-color: var(--color-bg-hover);\n}\n\n/* Short values that read badly split across lines (names, phones, dates,\n   status badges, buttons). Email is left free to wrap if it has to. */\n.candidate-table td.nowrap {\n  white-space: nowrap;\n}\n\n/* Flex lives on a wrapper, not the <td>, so the cell keeps table layout. */\n.row-actions {\n  display: flex;\n  gap: 10px;\n}\n\n/* Status badges */\n.status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: capitalize;\n  background-color: var(--wylie-purple);\n  color: #b494d1;\n  width: fit-content;\n  align-self: flex-start;\n}\n\n/* New Status - Brand Pink */\n.status-new {\n  background-color: var(--wylie-pink);\n  color: var(--wylie-white);\n}\n\n/* Part 1 - Interview (the pane's gold yellow; dark text, white is unreadable on it).\n   The pale badges are written .status-badge.status-x so their dark text outranks\n   `.info-item span` on the candidate page, which otherwise turns it light. */\n.status-badge.status-cv_received,\n.status-badge.status-background_check,\n.status-badge.status-phone_interview_scheduled,\n.status-badge.status-phone_interview_completed,\n.status-badge.status-in_person_interview_scheduled,\n.status-badge.status-in_person_interview_completed,\n.status-badge.status-trial_day_scheduled,\n.status-badge.status-trial_day_completed {\n  background-color: var(--part1-color);\n  color: #1f1f1f;\n}\n\n/* Rejected - Coral, like the Reject button and the Dashboard's Rejected figure */\n.status-badge.status-rejected {\n  background-color: var(--wylie-coral);\n  color: var(--wylie-white);\n}\n\n/* Part 2 - Job Offer (Coral) */\n.status-offer_sent,\n.status-offer_accepted,\n.status-references_requested,\n.status-reference_received,\n.status-referee_details_received {\n  background-color: #f05f57;\n  color: var(--wylie-white);\n}\n\n/* Part 3 - Documents (Blue) */\n.status-documents_email_sent,\n.status-all_starter_docs_received {\n  background-color: #288bcd;\n  color: var(--wylie-white);\n}\n\n/* Part 4 - Contract (Green). candidate_signed was missing here and showed in the\n   default purple (Pascal, 2026-10-17). */\n.status-contract_email_sent,\n.status-awaiting_contract_signature,\n.status-candidate_signed,\n.status-contract_signed {\n  background-color: #28a745;\n  color: var(--wylie-white);\n}\n\n/* Part 5 - Onboarding (Purple) */\n.status-onboarding_checklist_complete {\n  background-color: #9b4fc4;\n  color: var(--wylie-white);\n}\n\n/* Part 6 - Induction (Pink) */\n.status-awaiting_induction_signatures {\n  background-color: #dc2565;\n  color: var(--wylie-white);\n}\n\n/* Part 6 complete - Brand Nav Purple */\n.status-induction_folder_complete {\n  background-color: var(--wylie-purple);\n  color: var(--wylie-white);\n}\n\n/* Final Success State - Brand Green */\n.status-recruited {\n  background-color: var(--wylie-green);\n  color: var(--wylie-white);\n  font-weight: 600;\n}\n\n/* Archive marker. NOT a status — it sits alongside the status badge, because\n   archived is a separate axis (an archived candidate keeps whatever status they\n   reached). Styled as a secondary marker so it never competes with the status. */\n.status-archived {\n  background-color: transparent;\n  border: 1px solid var(--color-border);\n  color: var(--color-text-muted);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  margin-left: 6px;\n}\n\n/* Student/trainee → RVN progression: the linked-record tag beside the position. */\n.status-badge.status-progression {\n  background-color: transparent;\n  border: 1px solid var(--part1-color, #F7D002);\n  color: var(--part1-color, #F7D002);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  margin-left: 6px;\n}\n\n/* Flag badges for forms and documents */\n.flag-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  margin-left: auto;\n  white-space: nowrap;\n}\n\n.flag-badge.flag-warning {\n  background-color: rgba(255, 193, 7, 0.2);\n  color: #ffc107;\n  border: 1px solid #ffc107;\n}\n\n.flag-badge.flag-received {\n  background-color: var(--wylie-purple);\n  color: #e5e7eb;\n  border: none;\n}\n\n/* Forms */\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 500;\n  color: var(--color-text-light);\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid var(--color-border);\n  border-radius: 4px;\n  font-size: 14px;\n  background-color: var(--color-bg-card);\n  color: var(--color-text-light);\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--wylie-purple);\n  box-shadow: 0 0 0 0.2rem rgba(80, 7, 120, 0.25);\n}\n\n.error-message {\n  background-color: rgba(240, 95, 87, 0.2);\n  color: var(--wylie-coral);\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  border: 1px solid var(--wylie-coral);\n}\n\n/* ---- Next-step glow -------------------------------------------------------\n   One element per open part pulses to show what to do next; CandidateDetail\n   works out which from the candidate's data. The colour is the nearest\n   --glow-color (each part's frame sets its own); a button outside any frame\n   falls back to its own --btn-color, then the brand pink. */\n.next-glow {\n  --_glow: var(--glow-color, var(--btn-color, var(--wylie-pink, #dc2565)));\n  animation: nextGlow 4s ease-in-out infinite;\n}\n@keyframes nextGlow {\n  0%, 100% { box-shadow: 0 0 8px 1px color-mix(in srgb, var(--_glow) 40%, transparent); }\n  50%      { box-shadow: 0 0 18px 4px color-mix(in srgb, var(--_glow) 80%, transparent); }\n}\n/* Text that is being waited on (a send-status line, a header label, a number)\n   pulses from its own colour to light grey and back. Only the midpoint is\n   written: a keyframe that omits a property takes the element's own value, so\n   the start and end are whatever colour the text already has — inline styles\n   included, since animations sit above them in the cascade. */\n.next-glow-text {\n  animation: nextGlowText 4s ease-in-out infinite;\n}\n@keyframes nextGlowText {\n  50% { color: #e2e2e2; }\n}\n/* A muted status line that glows should pulse from the part's colour, not from\n   grey. Its colour is an inline `var(--color-text-muted)`, so the variable is\n   re-pointed here rather than fighting the inline style with !important (which\n   would also block the animation). */\n.next-glow-tint {\n  --color-text-muted: var(--glow-color, var(--btn-color, var(--wylie-pink, #dc2565)));\n}\n/* Dashboard: everything there glows at once, so it is kept softer. */\n.next-glow-soft { animation-name: nextGlowSoft; }\n@keyframes nextGlowSoft {\n  0%, 100% { box-shadow: 0 0 5px 0 color-mix(in srgb, var(--_glow) 30%, transparent); }\n  50%      { box-shadow: 0 0 12px 2px color-mix(in srgb, var(--_glow) 60%, transparent); }\n}\n@media (prefers-reduced-motion: reduce) {\n  .next-glow, .next-glow-text { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
